import { Mark, mergeAttributes } from "@tiptap/core";

export interface WaitlistLinkMarkOptions {
  HTMLAttributes: Record<string, any>;
}

/**
 * Read-only mark for waitlist links in the article viewer.
 * Renders as a span with data-waitlist-link attribute.
 * Click handling is done at the PostViewer level.
 */
export const WaitlistLinkMark = Mark.create<WaitlistLinkMarkOptions>({
  name: "waitlistLink",

  priority: 1000,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-waitlist-link]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-waitlist-link": "true",
        class: "waitlist-link",
      }),
      0,
    ];
  },
});

export default WaitlistLinkMark;
